<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="餐厅名称" prop="name">
      <el-input v-model="addEditForm.name" placeholder="请输入餐厅名称"></el-input>
    </el-form-item>
<!--    <el-form-item label="备注" prop="">-->
<!--      <el-input type="textarea" :rows="2" v-model="addEditForm.project_remark" placeholder="请输入备注"></el-input>-->
<!--    </el-form-item>-->
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {addrestaurant, updaterestaurant} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditRestaurant',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    restaurantObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addEditForm: {
        'id': 0,
        'eid': 1,
        'name': '',
        deletedat: ''
      },
      addEditRules: {
        name: [
          {required: true, message: '请输入餐厅名称', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    if (!this.restaurantObj.isAdd) {
      this.addEditForm.id = this.restaurantObj.row.id
      this.addEditForm.eid = this.restaurantObj.row.eid
      this.addEditForm.name = this.restaurantObj.row.name
      this.addEditForm.deletedat = this.restaurantObj.row.deletedat
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.restaurantObj.isAdd) {
            let data = {
              name: this.addEditForm.name,
              eid: this.$store.state.user.LoginResp.entity_id
            }
            addrestaurant(data).then(res => {
              this.$notify({title: '成功', message: '成功新增餐厅', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              eid: this.addEditForm.eid,
              name: this.addEditForm.name,
              deletedat: this.addEditForm.deletedat
            }
            updaterestaurant(data).then(res => {
              this.$notify({title: '成功', message: '成功新增餐厅', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditRestaurant.vue